/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
import { useWindowSize } from '@brands/hooks';
import { customStylesDashboard } from '@brands/Utils/customStyles';
import { Button } from '@mui/material';
import React, { FC, useMemo } from 'react';
import Modal, { Styles } from 'react-modal';

import closeICon from '../../Patient/components/closeIconSVG.svg';
import styles from './styles.module.scss';

export interface AddAdditionalInformationFormSubmit {
  notes: string;
  images: string[];
  caseId: string;
}

interface UnsavedChangesModalProps {
  isOpen: boolean;
  toggleModal?: (value: boolean) => void;
  closeParentModal?: (value: boolean) => void;
  saveChange: () => void;
  onConfirm?: () => void;
  loading: boolean;
  hideModal: () => void;
}

const mobileCustomStylesDashboard: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...(customStylesDashboard?.overlay || {}),
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    overflowY: 'scroll' as const,
    overflowX: 'hidden' as const,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    ...(customStylesDashboard?.content || {}),
    width: '320px',
    height: '268px',
    padding: '90px 16px 32px 16px',
    margin: '0',
    borderRadius: '8px',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto',
  },
};

const customStylesDashboardDesktop: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...customStylesDashboard.overlay,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  content: {
    position: 'relative',
    padding: '55px 32px 32px',
    borderRadius: '4px',
    width: '444px',
    maxHeight: '90vh',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
};
const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  isOpen,
  toggleModal,
  closeParentModal,
  saveChange,
  loading,
  onConfirm,
  hideModal,
}) => {
  const screenSize = useWindowSize();
  const isMobile = useMemo(() => screenSize.width < 768, [screenSize.width]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => hideModal()}
      style={isMobile ? mobileCustomStylesDashboard : customStylesDashboardDesktop}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <div className={styles.closeICon}>
        <img src={closeICon} onClick={() => hideModal()} />
      </div>

      <div className={styles.removeItemContainer}>
        <div>
          <span className={`fs-unmask ${styles.removeModalHeader}`}>Unsaved changes</span>
          <span className={`fs-unmask ${styles.removeModalSubtile}`}>
            Do you want to save your changes before leaving this page?
          </span>
        </div>
        <div>
          <Button
            variant="contained"
            className={`fs-unmask ${styles.save}`}
            color="primary"
            onClick={() => saveChange()}
            disabled={loading}
            data-testid="unsaved-change-modal-save-changes"
          >
            Save changes
          </Button>
          <Button
            variant="text"
            color="primary"
            className={`fs-unmask ${styles.cancel}`}
            onClick={() => {
              onConfirm && onConfirm();
              toggleModal && toggleModal(false);
              closeParentModal && closeParentModal(false);
            }}
            data-testid="unsaved-change-modal-discard"
          >
            Discard
          </Button>
        </div>
      </div>
    </Modal>
  );
};

Modal.setAppElement('#root');

export default UnsavedChangesModal;
